export class BerryDefaultConfig {
  static isCollapse_menu = false;
  static font_family = 'Roboto'; // Roboto, poppins, inter
}
